import React from 'react'
import PropTypes from 'prop-types'
import LinearProgress from '@material-ui/core/LinearProgress'
import gql from 'graphql-tag'
import { Query } from '@apollo/client/react/components'
import StoryPage, { storyFragment } from '@layouts/story'
import { getProfileSchema } from '@schema/coach-profile'
import { path, pathOr } from 'ramda'
import Error from '@components/error'
import { PromoBlockBySlugQuery } from '@components/content-promo-block/content-promo-block.query'

export const storySlugQuery = gql`
query BySlug($slug: String, $preview: Boolean) {
  storyCollection(limit: 1, preview: $preview, where: {slug: $slug}) {
    total
    items {
      ${storyFragment}
    }
  }
}
`

export const storyIdQuery = gql`
query BySlug($id: String!) {
  story(id: $id) {
    ${storyFragment}
  }
}
`

const COACH_QUERY = gql`
  query CoachProfiles($universalId: String) {
    CoachProfiles(universalId: $universalId) {
      message,
      profiles {
        ${getProfileSchema}
      }
    }
  }
`

const StoryPageWithPromoBlock = (props) => {
  return (
    <Query query={PromoBlockBySlugQuery} variables={{ slug: 'story' }}>
      {({
        loading, error, data,
      }) => {
        if (error) {
          return <Error error={error} displayErrorType="page" />
        }
        if (loading) return <LinearProgress color="secondary" />
        const promoBlock = data?.contentPromoBlockCollection?.items[0]
        return <StoryPage {...props} promoBlock={promoBlock} />
      }}
    </Query>
  )
}

const StoryWithCoach = (props) => {
  const { person } = props
  if (person && person.coachId) {
    return (
      <Query query={COACH_QUERY} variables={{ universalId: person.coachId }} context={{ clientName: 'coach-tools' }}>
        {({
          loading, error, data,
        }) => {
          if (error) {
            return <Error error={error} displayErrorType="page" />
          }
          if (loading) return <LinearProgress color="secondary" />
          const coachProfile = pathOr(null, ['CoachProfiles', 'profiles'], data)
          return <StoryPageWithPromoBlock {...props} coachProfile={coachProfile} />
        }}
      </Query>
    )
  }
  return <StoryPageWithPromoBlock {...props} />
}

StoryWithCoach.propTypes = {
  person: PropTypes.object,
}

const Story = (props) => {
  const { query } = props

  return (
    <Query query={query.slug ? storySlugQuery : storyIdQuery} variables={query}>
      {({
        loading, error, data,
      }) => {
        if (error) return <Error error={error} />
        if (loading) return <LinearProgress color="secondary" />

        const {
          storyCollection,
          story,
        } = data

        const storyData = story || path(['items', '0'], storyCollection)


        return storyData ? (
          <StoryWithCoach {...storyData} published={storyData.sys.firstPublishedAt} />
        ) : <Error statusCode={404} />
      }}
    </Query>
  )
}

Story.getInitialProps = async ({ query }) => ({ query })

Story.propTypes = {
  query: PropTypes.object,
}

export default Story
